<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Page-heading" id="_idParaDest-2"><a id="_idTextAnchor001"></a>Titlpage</p>
<p class="Prelims"><img alt="" class="_idGenObjectAttribute-1" src="Images/1.jpg"/></p>
<p class="Prelims ParaOverride-1"><img alt="" class="_idGenObjectAttribute-2" src="Images/2.jpg"/></p>
<p class="Prelims ParaOverride-1"><img alt="" class="_idGenObjectAttribute-3" src="Images/Title_Page_-_14874.jpg"/></p>
<p class="Body ParaOverride-2" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="da-DK"> </span><span class="CharOverride-2">by</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Christina M. Mizerak</span></p>
<p class="Basic-Paragraph ParaOverride-4"><span class="CharOverride-3"><img alt="" class="_idGenObjectAttribute-4" src="Images/Logo-for-titlepages-RGB-500px.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645360742_EPUB1.vue?2baff487